import { motion } from "framer-motion";
import { MdError, MdInfoOutline } from "react-icons/md";

const NotProfileFound = () => {
    return (
        <>
            <section className="min-h-[100vh] flex items-center justify-center bg-gradient-to-br from-red-50 to-pink px-6">
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6 }}
                    className="bg-white shadow-2xl rounded-3xl p-10 md:p-14 text-center max-w-xl w-full"
                >
                    <motion.div
                        animate={{ scale: [1, 1.1, 1] }}
                        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                        className="flex justify-center mb-6"
                    >
                        <MdInfoOutline className="text-red-500 text-7xl md:text-8xl" />
                    </motion.div>

                    <motion.h2
                        className="text-3xl md:text-4xl font-extrabold text-gray-800 mb-3"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2, duration: 0.5 }}
                    >
                        Profile Unavailable for Now
                    </motion.h2>

                    <motion.p
                        className="text-gray-600 text-base md:text-lg mb-8"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.4, duration: 0.5 }}
                    >
                        It looks like this profile hasn’t been set up yet.
                        Please create your profile to get started!
                    </motion.p>
                </motion.div>
            </section>
        </>
    );
}

export default NotProfileFound